import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

/**
 * A service dedicated to fetching NetSuite integration data from Google Sheets.
 * This service extends the base class to handle the core HTTP requests,
 * allowing this service to focus on defining the data endpoints.
 *
 * Sheet tab: 'netsuite'
 * Column A: Diversity Standing
 * Column B: Business Structure
 * Column C: 1099 Category
 */
@Injectable({
  providedIn: 'root'
})
export class NetSuiteSheetsService extends GoogleSheetsBaseService {

  /**
   * Gets the list of Diversity Standing options.
   * @returns An observable of the diversity standing options.
   */
  getDiversityStanding(): Observable<any> {
    return this.getSheetColumnData('netsuite', 'A2', 'A21').pipe(
      map(response => response || [])
    );
  }

  /**
   * Gets the list of Business Structure options.
   * @returns An observable of the business structure options.
   */
  getBusinessStructures(): Observable<any> {
    return this.getSheetColumnData('netsuite', 'B2', 'B21').pipe(
      map(response => response || [])
    );
  }

  /**
   * Gets the list of 1099 Category options.
   * @returns An observable of the 1099 category options.
   */
  get1099Categories(): Observable<any> {
    return this.getSheetColumnData('netsuite', 'C2', 'C21').pipe(
      map(response => response || [])
    );
  }
}
